// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"organizationListPanel_cardContent__2Sps6","ul":"organizationListPanel_ul__2YQpw","card":"organizationListPanel_card__K3_Ux"};